export interface RegisterRequestDto {
  email: string;
  password: string;
}

export interface LoginRequestDto {
  email: string;
  password: string;
}

export interface UserDto {
  id: string;
  email: string;
  isPremium: boolean;
  spotifyConnected: boolean;
  youtubeConnected: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface LoginResponseDto {
  accessToken: string;
  user: UserDto;
}

export interface UpdatePremiumDto {
  isPremium: boolean;
}

export interface ConnectUrlResponse {
  authorizationUrl: string;
}

export interface SpotifyAccountDto {
  accessToken: string;
  refreshToken: string;
  expiresAt: string;
}

export interface YoutubeAccountDto {
  accessToken: string;
  refreshToken: string;
  expiresAt: string;
}

export interface SpotifyTrack {
  spotifyId: string;
  title: string;
  artistNames: string[];
  albumName: string;
  durationMs: number;
  isrc?: string;
  releaseYear?: number;
}

export interface YoutubeVideo {
  youtubeId: string;
  title: string;
  channelTitle: string;
  durationSeconds: number;
  viewCount?: number;
  description?: string;
}

export type SourceTrack = SpotifyTrack | YoutubeVideo;

export interface TrackConversionResultDto {
  sourceTrack: SourceTrack;
  matchedTarget?: SourceTrack;
  matchScore: number;
  confidenceLevel: 'HIGH' | 'MEDIUM' | 'LOW' | 'NO_MATCH';
  candidates?: SourceTrack[];
}

export interface PlaylistDto {
  id: string;
  conversionId?: string;
  sourcePlatform: 'spotify' | 'youtube';
  targetPlatform: 'spotify' | 'youtube';
  sourcePlaylistUrl: string;
  targetPlaylistUrl?: string;
  title: string;
  status: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'FAILED';
  trackCount?: number;
  progress?: number;
  processedCount?: number;
  total?: number;
  errorMessage?: string;
  sourceTitle?: string;
  sourceTrackCount?: number;
  targetTitle?: string;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedPlaylists {
  items: PlaylistDto[];
  total: number;
  page: number;
  limit: number;
}

export interface ConvertPlaylistDto {
  sourcePlatform: 'spotify' | 'youtube';
  targetPlatform: 'spotify' | 'youtube';
  playlistUrl: string;
  mode?: 'ECO' | 'FULL';
}

export interface PlaylistInfoDto {
  id: string;
  name: string;
  trackCount: number;
  url?: string;
}

export interface ConversionStatusDto {
  conversionId: string;
  status: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'FAILED';
  progress?: number;
  errorMessage?: string;
  sourcePlatform: 'spotify' | 'youtube';
  targetPlatform: 'spotify' | 'youtube';
  sourceTitle?: string;
  sourceTrackCount?: number;
  targetTitle?: string;
  targetPlaylistUrl?: string;
  added?: TrackConversionResultDto[];
  skipped?: TrackConversionResultDto[];
  current?: TrackConversionResultDto | null;
  total?: number;
  processedCount?: number;
  mode?: 'ECO' | 'FULL';
}

export interface ConvertPlaylistResponseDto extends ConversionStatusDto {
  playlistId: string;
  sourcePlaylistInfo?: PlaylistInfoDto;
  targetPlaylistInfo?: PlaylistInfoDto;
  results?: TrackConversionResultDto[];
}

export interface RematchRequestDto {
  conversionId: string;
  sourcePlatform: 'spotify' | 'youtube';
  targetPlatform: 'spotify' | 'youtube';
  sourceTrackId: string;
  currentTargetId?: string;
}

export interface TokensDto {
  allowance: number;
  used: number;
  remaining: number;
}
